import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {JowLoginResponse, LoginService} from '@irisims/justconsult-api';
import {TokenStorageService} from '@app/_services/token-storage.service';
import {TranslateService} from '@ngx-translate/core';
import {LangService} from '@app/_services/lang.service';
import {UserDataService} from '@app/_services/user-data.service';
import { ConsultationPageStateService } from '@app/pages/consultations/service/consultation-page-state.service';

@Component({
  selector: 'app-just-on-web-login',
  templateUrl: './just-on-web-login.component.html',
  styleUrls: ['./just-on-web-login.component.scss']
})
export class JustOnWebLoginComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private langStorageService: LangService,
              private userDataService: UserDataService,
              private consultationPageState: ConsultationPageStateService,
              private loginService: LoginService,
              private translate: TranslateService,
              private tokenStorageService: TokenStorageService) {
  }

  ngOnInit(): void {
    this.translate.currentLang = '';

    const data: JowLoginResponse = this.activatedRoute.snapshot.data?.login;
    if (data) {
      this.translate.use(data.language ? data.language : 'nl');
      this.tokenStorageService.saveToken(data.accessToken);
      this.tokenStorageService.saveRefreshToken(data.renewToken);
      this.langStorageService.saveLanguage(data.language);
      this.langStorageService.selectedLanguage$.next(data.language);
      this.userDataService.saveUserData({
        rrn: data.rrn,
        firstname: data.firstName,
        name: data.name
      });
    }
    this.consultationPageState.isWarningBannerDisplayed.next(true);
    this.router.navigate(['/consultation']).then();
  }
}
